<template>
  <vx-card id="manager-invoice-view" v-if="requestDetails">
    <invoice-data-view :invoice="invoice" :request="request" :request-details="requestDetails" />
    <div slot="footer" v-if="invoice.state === 'pending'">
      <vs-row vs-justify="flex-end" class="print-hidden">
        <vs-button icon-pack="feather" icon="icon-edit" color="primary" class="mr-2" @click="editInvoice()">
          {{ $t('forms.edit') }}
        </vs-button>
        <vs-button icon-pack="feather" icon="icon-check" color="success" @click="activeDonePopup = true">
          {{ $t('invoices.done') }}
        </vs-button>
      </vs-row>
    </div>
    <div slot="footer" v-else-if="invoice.state === 'cash_unpaid'">
      <vs-row vs-justify="flex-end" class="print-hidden">
        <vs-button
          color="success"
          id="button-pay-loading"
          class="vs-con-loading__container mx-2"
          :disabled="payBtnDisable"
          @click="payInvoice"
        >
          {{ $t('invoices.pay') }}
        </vs-button>
      </vs-row>
    </div>
    <vs-popup :active="activeDonePopup" @close="activeDonePopup = false" :title="$t('invoices.done_title')">
      <vs-textarea
        v-model="commendation"
        name="commendation"
        id="commendation"
        :label="$t('invoice.commendation')"
        class="w-full"
      />
      <vs-row vs-justify="flex-end">
        <vs-button icon-pack="feather" icon="icon-check" color="success" class="mt-3" @click="doneInvoice()">
          {{ $t('invoices.done') }}
        </vs-button>
      </vs-row>
    </vs-popup>
  </vx-card>
</template>

<script>
import InvoiceDataView from '@/views/pages/invoice/InvoiceDataView'
import modulePayping from '@/store/payping/modulePayping'

export default {
  name: 'ManagerInvoiceView',
  components: { InvoiceDataView },
  data() {
    return {
      invoice: {},
      request: {},
      requestDetails: null,
      payBtnDisable: false,
      activeReserveEditPopup: false,
      activeDonePopup: false
    }
  },
  methods: {
    editInvoice() {
      this.$router.push({ name: 'business-invoice-edit', params: { id: this.invoice.id } })
    },
    doneInvoice() {
      this.$store
        .dispatch('request/updateRequestBySubject', {
          category: this.request.category,
          subject: this.request.subject,
          id: this.invoice.request.id,
          activity: 'InvoiceEditionConfirmation',
          data: { InvoiceEditionConfirmation: '', Commendation: this.commendation }
        })
        .then(() => {
          this.activeDonePopup = false
          this.$vs.notify({
            title: this.$t('invoices.done_successfully'),
            text: '',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          this.$router.push({ name: 'business-invoice-list' })
        })
        .catch(() => {
          this.activeDonePopup = false
        })
    },
    payInvoice() {
      this.payBtnDisable = true

      this.$vs.loading({
        background: 'success',
        container: '#button-pay-loading',
        color: '#fff',
        scale: 0.45
      })

      this.$store
        .dispatch('payping/fetchPaymentIpg', this.invoice.paypingPaymentId)
        .then(response => {
          window.location = response.data
        })
        .finally(() => {
          this.activeSurveyPrompt = false
          this.payBtnDisable = false
          this.$vs.loading.close('#button-pay-loading > .con-vs-loading')
        })
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    this.$store
      .dispatch('invoice/fetchInvoice', this.$route.params.id)
      .then(res => {
        this.invoice = JSON.parse(JSON.stringify(res.data))

        this.$store
          .dispatch('request/fetchHealthRequestById', this.invoice.request.id)
          .then(res => {
            this.request = JSON.parse(JSON.stringify(res.data))
            this.$store
              .dispatch('request/fetchRequestDetailsBySubject', {
                id: this.invoice.request.id,
                subject: this.request.subject,
                category: this.request.category
              })
              .then(res => {
                this.requestDetails = res.data
              })
          })
          .finally(() => this.$vs.loading.close())
      })
      .catch(() => this.$vs.loading.close())
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
